import React, { useState, useRef } from 'react';
import OfficeCard from './OfficeCard';
import Icon from '../../../components/AppIcon';


const DragDropOfficeList = ({ 
  offices, 
  onReorder, 
  selectedOffices, 
  onOfficeSelect, 
  onOfficeEdit, 
  onOfficeDelete, 
  onOfficeView,
  className = '' 
}) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const dragCounter = useRef(0);

  const handleDragStart = (e, office, index) => {
    setDraggedItem({ office, index });
    e.dataTransfer.effectAllowed = 'move';
    e?.dataTransfer?.setData('text/html', e?.target?.outerHTML);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDragOverIndex(null);
    dragCounter.current = 0;
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e, index) => {
    e?.preventDefault();
    dragCounter.current++;
    setDragOverIndex(index);
  };

  const handleDragLeave = (e) => {
    dragCounter.current--;
    if (dragCounter?.current === 0) {
      setDragOverIndex(null);
    }
  };

  const handleDrop = (e, targetIndex) => {
    e?.preventDefault();
    
    if (!draggedItem || draggedItem?.index === targetIndex) {
      return;
    }

    const newOffices = [...offices];
    const [movedOffice] = newOffices?.splice(draggedItem?.index, 1);
    newOffices?.splice(targetIndex, 0, movedOffice);

    // Update order values
    const reorderedOffices = newOffices?.map((office, index) => ({
      ...office,
      order: index + 1
    }));

    onReorder(reorderedOffices);
    setDraggedItem(null);
    setDragOverIndex(null);
    dragCounter.current = 0;
  };

  const getDragHandleProps = (office, index) => ({
    draggable: true,
    onDragStart: (e) => handleDragStart(e, office, index),
    onDragEnd: handleDragEnd,
  });

  if (!offices || offices?.length === 0) {
    return (
      <div className={`text-center py-12 ${className}`}>
        <div className="text-muted-foreground">
          <div className="w-16 h-16 mx-auto mb-4 bg-muted rounded-full flex items-center justify-center">
            <Icon name="Briefcase" size={24} />
          </div>
          <p className="text-lg font-medium mb-2">لا توجد مناصب</p>
          <p className="text-sm">ابدأ بإضافة منصب جديد لهذه الفئة</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`space-y-4 ${className}`}>
      {offices?.map((office, index) => {
        const isDragging = draggedItem?.index === index;
        const isDragOver = dragOverIndex === index;
        
        return (
          <div
            key={office?.id}
            className={`transition-all duration-200 ${
              isDragOver ? 'transform scale-105' : ''
            }`}
            onDragOver={handleDragOver}
            onDragEnter={(e) => handleDragEnter(e, index)}
            onDragLeave={handleDragLeave}
            onDrop={(e) => handleDrop(e, index)}
          >
            {/* Drop Zone Indicator */}
            {isDragOver && draggedItem?.index !== index && (
              <div className="h-2 bg-primary rounded-full mb-2 animate-pulse" />
            )}
            <OfficeCard
              office={office}
              onEdit={onOfficeEdit}
              onDelete={onOfficeDelete}
              onView={onOfficeView}
              isSelected={selectedOffices?.includes(office?.id)}
              onSelect={onOfficeSelect}
              isDragging={isDragging}
              dragHandleProps={getDragHandleProps(office, index)}
              showDragHandle={true}
            />
          </div>
        );
      })}
      {/* Final Drop Zone */}
      {draggedItem && (
        <div
          className="h-16 border-2 border-dashed border-primary rounded-lg flex items-center justify-center text-primary animate-pulse"
          onDragOver={handleDragOver}
          onDragEnter={(e) => handleDragEnter(e, offices?.length)}
          onDragLeave={handleDragLeave}
          onDrop={(e) => handleDrop(e, offices?.length)}
        >
          <span className="text-sm font-medium">إسقاط هنا لإضافة في النهاية</span>
        </div>
      )}
    </div>
  );
};

export default DragDropOfficeList;